import { render, staticRenderFns } from "./DetailUserMerchant.vue?vue&type=template&id=00bf9496"
import script from "./DetailUserMerchant.vue?vue&type=script&lang=js"
export * from "./DetailUserMerchant.vue?vue&type=script&lang=js"
import style0 from "./DetailUserMerchant.vue?vue&type=style&index=0&id=00bf9496&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports